<template>
  <div :ref="item.id" class="survey" v-bind:class="headtailClass">
    <div class="survey_info">
      <span class="necessary" v-if="item.required">필수</span>
      <span class="choice_n" v-if="item.answer_flag === 'B'">복수 선택</span>
    </div>

    <div class="surveyTitle">
      <h3>
        <span class="num">{{item.idx}}</span>
        {{item.title}}
      </h3>

      <div class="img" v-if="imagejimuns.length > 0">
        <img :src="image.url" alt="테스트이미지" v-bind:key="image.name" v-for="image in imagejimuns" />
      </div>
    </div>

    <div v-if="item.answer_flag  !== 'C'" class="exampleWrap">
      <div class="example_list" v-bind:key="bogi.id" v-for="bogi in bogis">
        <div class="checkbox">
          <input
            v-model="bogi.chk"
            type="checkbox"
            :disabled="bogi.disabled"
            :name="bogi.id"
            :id="bogi.id"
            @change="sendQ(bogi)"
          />
          <label :for="bogi.id">{{bogi.title}}</label>
        </div>
      </div>
    </div>
    <div v-if="item.answer_flag === 'C'" class="exampleWrap">
      <!-- 주관식 대응 -->
      <div class="exampleinput">
        <input :id="item.id" type="text" v-model="CValue" />
      </div>
    </div>

    <a v-if="item.answer_flag !== 'A'" @click.prevent="sendSum" href class="btn check" title="확인">확인</a>
  </div>
</template>

<script>
import * as R from "ramda";
export default {
  props: ["item", "flag"],
  created() {
    console.log(this.item);
  },
  data() {
    return {
      bogis2: [...this.item.Itemdetails],
      checkedCount: 0,
      CValue: ""
    };
  },
  computed: {
    bogis() {
      return this.item.Itemdetails;
    },
    headtailClass() {
      // console.log(this.item);
      if (this.item != undefined) {
        if (this.item.first) {
          return "first";
        } else if (this.item.last) {
          return "last";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    imagejimuns() {
      let k = JSON.parse(this.item.jimun_multi);
      k = R.reject(x => x.type !== "image", k);
      return k;
    }
  },
  methods: {
    sendQ(bogi) {
      let that = this;
      let $that = this;

      this.checkedCount = R.filter(x => {
        return x.chk;
      }, this.bogis).length;

      //todo: decresed number of user sent
      let _k = this.$store.state.non_answers;
      if (this.checkedCount === 0) {
        _k = R.reject(x => {
          return x === $that.item.id;
        }, _k);
        _k = R.uniq(_k);
        this.$store.state.non_answers = _k;
      }

      if (this.item.answer_flag[0] === "D") {
        let max_cnt = parseInt(this.item.answer_flag[1]);

        if (this.checkedCount >= max_cnt) {
          this.bogis.forEach((b, i) => {
            if (!b.chk) {
              let f4 = that.bogis[i];
              f4.disabled = "disable";
              that.$set(that.bogis, i, f4);
            }
          });
        } else {
          this.bogis.forEach((b, i) => {
            let f4 = that.bogis[i];
            f4.disabled = null;
            that.$set(that.bogis, i, f4);
          });
        }

        return;
      }

      if (this.item.answer_flag !== "A") {
        // A타입이 아니면 취소
        return;
      }

      if (this.checkedCount === 0) {
        let _k = this.$store.state.non_answers;
        _k = R.reject(x => x === this.item.id, _k);
        _k = R.uniq(_k);
        this.$store.state.non_answers = _k;
      } else {
        let _k = this.$store.state.non_answers;
        _k = R.append(this.item.id, _k);
        _k = R.uniq(_k);
        this.$store.state.non_answers = _k;
      }

      // bogi.chk = !bogi.chk;
      this.bogis.forEach((b, i) => {
        if (b.id !== bogi.id) {
          let f4 = this.item.Itemdetails[i];

          f4.chk = false;
          this.$set(this.item.Itemdetails, i, f4);
        }
      });

      let url = this.$Constant.NonItemPost;
      let answer = [bogi.id];

      this.$axios
        .post(url, {
          item_id: this.item.id,
          item_answer: JSON.stringify(answer),
          point: 0,
          item_apply_id: this.item.apply_id,
          item_apply_log_id: this.item.apply_log_id,
          answer_flag: this.item.answer_flag,
          flag: this.flag,

          etc: null
        })
        .then(resp => {
          this.item.apply_log_id = resp.data.id;
        });

      if (this.item.next_item_id != null) {
        document.getElementById(this.item.next_item_id).scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center"
        });
      }
    },
    shake(target_element) {
      let xMax = 16;
      this.$anime({
        targets: target_element,
        duration: 550,
        easing: "easeInOutSine",
        translateX: [
          {
            value: xMax * -1
          },
          {
            value: xMax
          },
          {
            value: xMax / -2
          },
          {
            value: xMax / 2
          },
          {
            value: 0
          }
        ]
      });
    },
    sendSum() {
      //todo: submit with multiple answers

      let answer = null;

      if (this.item.answer_flag === "C") {
        // 주관식이면
        if (this.CValue === "") {
          this.shake(this.$refs[this.item.id]);
          return;
        }
        answer = [this.CValue];
      } else {
        answer = R.filter(x => x.chk == true, this.bogis).reduce((x, y) => {
          x.push(y.id);
          return x;
        }, []);

        if (answer.length === 0) {
          this.shake(this.$refs[this.item.id]);
          return;
        }
      }
      //done: collect users answers

      let url = this.$Constant.NonItemPost;
      this.$axios
        .post(url, {
          item_id: this.item.id,
          item_answer: JSON.stringify(answer),
          point: 0,
          item_apply_id: this.item.apply_id,
          item_apply_log_id: this.item.apply_log_id,
          answer_flag: this.item.answer_flag,
          flag: this.flag,
          etc: null
        })
        .then(resp => {
          this.item.apply_log_id = resp.data.id;
        });
      if (this.item.next_item_id != null) {
        document.getElementById(this.item.next_item_id).scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center"
        });
      }

      let _k = this.$store.state.non_answers;
      _k = R.append(this.item.id, _k);
      _k = R.uniq(_k);
      this.$store.state.non_answers = _k;
    }
  }
};
</script>


<style lang="scss" scoped>
</style>